import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { PawPrint } from "lucide-react";
import Dashboard from "@/pages/Dashboard";
import Dogs from "@/pages/Dogs";
import DogDetail from "@/pages/DogDetail";
import AIResearch from "@/pages/AIResearch";
import Behaviour from "@/pages/Behaviour";
import Training from "@/pages/Training";
import Courses from "@/pages/Courses";
import Manage from "@/pages/Manage";
import About from "@/pages/About";
import Community from "@/pages/Community";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Upgrade from "@/pages/Upgrade";
import Landing from "@/pages/Landing";
import Directory from "@/pages/Directory";

const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="h-12 w-12 rounded-2xl bg-primary flex items-center justify-center text-primary-foreground animate-pulse"><PawPrint className="h-6 w-6" /></div>
  </div>
);

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function Home() {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Landing />;
  return <Layout><Dashboard /></Layout>;
}

function AppRoutes() {
  const location = useLocation();
  // Handle Google OAuth return (session_id in URL fragment) BEFORE anything else
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/directory" element={<Directory />} />
      <Route path="/" element={<Home />} />
      <Route path="/dogs" element={<Protected><Dogs /></Protected>} />
      <Route path="/dogs/:id" element={<Protected><DogDetail /></Protected>} />
      <Route path="/research" element={<Protected><AIResearch /></Protected>} />
      <Route path="/behaviour" element={<Protected><Behaviour /></Protected>} />
      <Route path="/training" element={<Protected><Training /></Protected>} />
      <Route path="/courses" element={<Protected><Courses /></Protected>} />
      <Route path="/manage" element={<Protected><Manage /></Protected>} />
      <Route path="/about" element={<Protected><About /></Protected>} />
      <Route path="/community" element={<Protected><Community /></Protected>} />
      <Route path="/upgrade" element={<Protected><Upgrade /></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
